import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SubDivision } from "@app/models/rest/roster/sub-division";

@Injectable({
  providedIn: "root"
})
export class SubDivisionRestService extends HateoasResourceOperation<SubDivision> {
  constructor() {
    super(SubDivision);
  }
}
